import React from 'react';
import {inject, observer} from 'mobx-react';
import {Modal, Popover} from 'antd';
import {WeaLocaleProvider, WeaTools, WeaHelpfulTip, WeaBrowser, WeaAvatar} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

import {WeaThemeCenter, WeaThemeLayout} from  'weaPortalPublic';

@inject('portalThemeStore')
@observer
class E9AccountContent extends React.Component {
    constructor(props) {
        super(props);
        this.onOpenCard = this.onOpenCard.bind(this);
        this.onChangeAccount = this.onChangeAccount.bind(this);
        this.onFontSizeChange = this.onFontSizeChange.bind(this);
        this.onLangChange = this.onLangChange.bind(this);
        this.onShowThemeCenter = this.onShowThemeCenter.bind(this);
        this.onLogout = this.onLogout.bind(this);
    }

    render() {
        const {portalThemeStore, account, accountSize, accountList, accountMoreMenu} = this.props;
        const {multiLangs, langId, themeInfo, fontSettingVisible, langSettingVisible} = portalThemeStore;
        const {themeFontSize = '12'} = themeInfo;
        const {userid:curuserid, showSearch, fontSetting} = account;
        let langText = '';
        multiLangs.forEach((item) => {
            if (item.id == langId) {
                langText = item.language;
            }
        });

        return (
            <div id="e9header-account-content" className="e9header-account-content">
                {
                    accountSize > 1 ? (
                            <div>
                                <div className="e9header-account-title">
                                    <span>{getLabel(131608, '主次账号切换')}</span>
                                </div>
                                {
                                    showSearch ? (
                                        <div className="e9header-account-search">
                                            <div className="e9header-account-search-title">
                                                <span>{getLabel(507638, '分部')}</span>
                                            </div>
                                            <div className="e9header-account-search-browser">
                                                <WeaBrowser
                                                    title={getLabel(507638, '分部')}
                                                    type={164}
                                                    isSingle={true}
                                                    tabs={[
                                                        {key: '1', name: getLabel(384541, '按组织架构'), selected: false},
                                                        {key: '2', name: getLabel(130619, '按列表'), selected: false, dataParams: {list: 1}}
                                                    ]}
                                                    hasAdvanceSerach={true}
                                                    getPopupContainer={() => document.getElementById('e9header-account-content')}
                                                    onOpen={() => window.accountVisible = true}
                                                    onClose={() => window.accountVisible = false}
                                                    onChange={id => portalThemeStore.getAccountList(id)}
                                                />
                                            </div>
                                            <div style={{clear: 'both'}} />
                                        </div>
                                    ) : ''
                                }
                                <div className="e9header-account-splitter"></div>
                            </div>
                        ) : ''
                }
                <div className="e9header-account-list">
                    {
                        accountList.map((item, index) => {
                            let {userid, usertype, username, jobs, subcompanyname, deptname} = item;
                            deptname = `${subcompanyname}/${deptname}`;
                            deptname = deptname == '/' ? '' : deptname;

                            return (
                                <div key={index}>
                                    <div className="e9header-account-item">
                                        <div className="e9header-account-item-img" onClick={e => this.onOpenCard(e, userid)}>
                                            <WeaAvatar userId={userid}/>
                                        </div>
                                        <div className="e9header-account-item-info"
                                            onClick={e => {
                                                if (accountSize > 1 && userid != curuserid) {
                                                  this.onChangeAccount(userid);
                                                } else {
                                                  this.onOpenCard(e, userid);
                                                }
                                            }}
                                        >
                                            {usertype == '0' && <span className="e9header-account-item-usertype"><i className="icon-coms02-Main-account-number"/></span>}
                                            <span title={username} className="e9header-account-item-username" onClick={e => this.onOpenCard(e, userid)}>{username}</span>
                                            <span title={jobs} className="e9header-account-item-jobs">{jobs}</span>
                                            <br />
                                            <div title={deptname} className="e9header-account-item-deptname">{deptname}</div>
                                        </div>
                                        {accountSize > 1 && userid == curuserid ? <i className="icon-coms02-icon-Completion e9header-account-checked" /> : ''}
                                    </div>
                                    <div className="e9header-account-splitter"></div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className="e9header-account-setting">
                    {
                        accountMoreMenu.map((item, index) => {
                            if (item.sType == 'font') {
                                return (
                                    <Popover
                                        key={index}
                                        trigger="click"
                                        placement="leftTop"
                                        content={<FontSizeSettingContent fontSize={themeFontSize} onChange={this.onFontSizeChange}/>}
                                        overlayClassName="e9header-font-setting-overlay"
                                        visible={fontSettingVisible}
                                        onVisibleChange={(visible) => portalThemeStore.onFontSettingVisibleChange(visible)}
                                    >
                                        <div className="e9header-account-setting-item" title={item.name} style={{paddingRight: 100}}>
                                            <i className={item.icon} />
                                            <span className="e9header-account-setting-title">{item.name}</span>
                                            <WeaHelpfulTip title={getLabel(386450, '注意：字体大小修改只对使用系统标准样式的内容有效，对于用户自行定义的样式（例如：流程表单内容、文档内容）不生效')}/>
                                            <span style={{position: 'absolute', right: '40px'}}>{{'12': getLabel(149, '默认'), '14': getLabel(18145, '中'), '16': getLabel(18144, '大')}[themeFontSize]}</span>
                                            <i className="icon-coms-organization-right" style={{position: 'absolute', right: '10px'}}/>
                                        </div>
                                    </Popover>
                                )
                            } else if (item.sType == 'language' && multiLangs && multiLangs.length > 1) {
                                return (
                                    <Popover
                                        key={index}
                                        trigger="click"
                                        placement="leftTop"
                                        content={<LangSettingContent langId={langId} multiLangs={multiLangs} onChange={this.onLangChange}/>}
                                        overlayClassName="e9header-lang-setting-overlay"
                                        visible={langSettingVisible}
                                        onVisibleChange={(visible) => portalThemeStore.onLangSettingVisibleChange(visible)}
                                    >
                                        <div className="e9header-account-setting-item" title={item.name} style={{paddingRight: 100}}>
                                            <i className={item.icon} />
                                            <span className="e9header-account-setting-title">{item.name}</span>
                                            <span style={{position: 'absolute', right: '40px'}}>{langText}</span>
                                            <i className="icon-coms-organization-right" style={{position: 'absolute', right: '10px'}}/>
                                        </div>
                                    </Popover>
                                );
                            } else if (item.sType == 'custom') {
                                return (
                                    <div key={index}
                                         className="e9header-account-setting-item"
                                         title={item.name}
                                         onClick={
                                             () => {
                                                 this.props.onVisibleChange(false);
                                                 portalThemeStore.onLoadMain({url: item.url});
                                             }
                                         }
                                    >
                                        <i className={item.icon}/>
                                        <span className="e9header-account-setting-title">{item.name}</span>
                                    </div>
                                );
                            } else if (item.sType == 'password') {
                                return (
                                    <div key={index}
                                         className="e9header-account-setting-item"
                                         title={item.name}
                                         onClick={
                                             () => {
                                                 this.props.onVisibleChange(false);
                                                 portalThemeStore.onLoadMain({url: item.url});
                                             }
                                         }
                                    >
                                        <i className={item.icon}/>
                                        <span className="e9header-account-setting-title">{item.name}</span>
                                    </div>
                                );
                            } else if (item.sType == 'theme') {
                                return (
                                    <div key={index}
                                         className="e9header-account-setting-item"
                                         title={item.name}
                                         onClick={
                                             () => {
                                                 this.props.onVisibleChange(false);
                                                 this.onShowThemeCenter();
                                             }
                                         }
                                    >
                                        <i className={item.icon}/>
                                        <span className="e9header-account-setting-title">{item.name}</span>
                                        <WeaThemeCenter ref="WeaThemeCenter"/>
                                    </div>
                                );
                            } else if (item.sType == 'layout') {
                                return (
                                    <div key={index}
                                         className="e9header-account-setting-item"
                                         title={item.name}
                                         onClick={
                                             () => {
                                                 this.props.onVisibleChange(false);
                                                 this.refs['WeaThemeLayout'].onShow();
                                             }
                                         }
                                    >
                                        <i className={item.icon}/>
                                        <span className="e9header-account-setting-title">{item.name}</span>
                                        <WeaThemeLayout ref="WeaThemeLayout"/>
                                    </div>
                                );
                            } else if (item.sType == 'logout') {
                                return (
                                    <div key={index} className="e9header-account-setting-item" title={item.name} onClick={this.onLogout}>
                                        <i className={item.icon}/>
                                        <span className="e9header-account-setting-title">{item.name}</span>
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })
                    }
                </div>
            </div>
        );
    }

    onOpenCard(e, userid) {
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
        
        const {portalThemeStore} = this.props;
        this.props.onVisibleChange(false);
        portalThemeStore.onLoadMain({mobxrouteurl: `/hrm/card/cardInfo/${userid}`});
    }

    onChangeAccount(userid) {
        WeaTools.ls.set('isInitLSValue', false);
        window.location.href = `/login/IdentityShift.jsp?shiftid=${userid}`;
    }

    onFontSizeChange(fontSize) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onFontSizeChange(fontSize);
        portalThemeStore.onFontSettingVisibleChange(false);
    }

    onLangChange(langId, langText) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onLangChange(langId, langText);
        portalThemeStore.onLangSettingVisibleChange(false);
    }

    onShowThemeCenter() {
        const {portalThemeStore} = this.props;
        const {themeInfo = {}} = portalThemeStore;

        if (themeInfo.themeAppoint) {
            Modal.confirm({
                title: getLabel(15172, '系统提示'),
                content: getLabel(126325, '分部已指定主题模板，不能修改!')
            });
        } else {
            this.refs['WeaThemeCenter'].onShow();
        }
    }

    onLogout() {
        this.props.onVisibleChange(false);

        const {portalThemeStore} = this.props;
        portalThemeStore.onLogout();
    }
}

class FontSizeSettingContent extends React.Component {
    render() {
        const {fontSize} = this.props;
        const selectedComp = <i className="icon-coms-Selected e9header-font-setting-selected"/>;

        return (
            <div className="e9header-font-setting-content">
                <div className="e9header-font-setting-item" onClick={() => this.props.onChange('16')}>
                    <i className="icon-coms-text" style={{fontSize: '16px'}}/>
                    <span style={{fontSize: '16px', marginLeft: '8px'}}>{getLabel(18144, '大')}</span>
                    {fontSize == '16' ? selectedComp : ''}
                </div>
                <div className="e9header-font-setting-item" onClick={() => this.props.onChange('14')}>
                    <i className="icon-coms-text" style={{fontSize: '14px'}}/>
                    <span style={{fontSize: '14px', marginLeft: '10px'}}>{getLabel(18145, '中')}</span>
                    {fontSize == '14' ? selectedComp : ''}
                </div>
                <div className="e9header-font-setting-item" onClick={() => this.props.onChange('12')}>
                    <i className="icon-coms-text" style={{fontSize: '12px'}}/>
                    <span style={{fontSize: '12px', marginLeft: '12px'}}>{getLabel(149, '默认')}</span>
                    {fontSize == '12' ? selectedComp : ''}
                </div>
            </div>
        );
    }
}

class LangSettingContent extends React.Component {
    render() {
        const selectedComp = <i className="icon-coms-Selected e9header-lang-setting-selected"/>;

        return (
            <div className="e9header-lang-setting-content">
                {
                    this.props.multiLangs.map((item, index) => {
                        return (
                            <div key={index} className="e9header-lang-setting-item" onClick={() => this.props.onChange(item.id, item.language)}>
                                <span>{item.language}</span>
                                {item.id == this.props.langId ? selectedComp : ''}
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default E9AccountContent;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9AccountContent.js